/**
 * Component type definitions.
 * Defines component name mappings and type identifiers.
 *
 * @module types/components-map
 */

/**
 * Mapping of component identifiers to their string representations.
 * Used for routing and component resolution.
 */
export enum ComponentNameMap {
  /** Full header with complete navigation */
  FULL_HEADER = 'full-header',
  /** Slim header with minimal navigation */
  SLIM_HEADER = 'slim-header',
  /** Full footer with all sections */
  FULL_FOOTER = 'full-footer',
  /** Slim footer with minimal content */
  SLIM_FOOTER = 'slim-footer',
}

/**
 * High-level component type identifiers.
 * Used for tracking and component categorization.
 */
export enum ComponentType {
  /** Header component type */
  HEADER = 'Header',
  /** Footer component type */
  FOOTER = 'Footer',
}
